// @ts-nocheck
import React, { ReactNode } from 'react';
import styled from 'styled-components';
const Title = styled.div.withConfig({
  displayName: "CustomStatistic__Title",
  componentId: "sc-1w8dilo-0"
})(["display:flex;justify-content:center;font-size:0.8em;text-transform:uppercase;font-weight:300;color:#677078;text-align:center;margin:6px 0 12px 0;"]);
const Card = styled.div.withConfig({
  displayName: "CustomStatistic__Card",
  componentId: "sc-1w8dilo-1"
})(["display:flex;flex-direction:column;align-items:stretch;height:100%;"]);
export default props => {
  return <Card>
      {props.children}
      <Title>{props.title}</Title>
    </Card>;
};
